import { useGetSchedulerRunHistoryQuery } from '@/api/portfolioApi';
import { formatDateTime } from '@/utils/formatters';
import { HistoryOutlined } from '@ant-design/icons';
import { Modal, Space, Spin, Table, Tag, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

const STATUS_COLORS = {
  SUCCESS: 'green',
  SKIPPED: 'default',
  ERROR: 'red',
  FAILED: 'red',
};

const renderMetadata = (value) => {
  if (!value) return <Text type="secondary">-</Text>;
  try {
    const parsed = JSON.parse(value);
    return (
      <pre style={{ margin: 0, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {JSON.stringify(parsed, null, 2)}
      </pre>
    );
  } catch {
    return <Text style={{ fontSize: 12 }}>{value}</Text>;
  }
};

const columns = [
  {
    title: 'Date / Time',
    dataIndex: 'createDate',
    key: 'createDate',
    width: 160,
    render: (value) => formatDateTime(value),
  },
  {
    title: 'Job Type',
    dataIndex: 'jobType',
    key: 'jobType',
    width: 150,
    render: (value) => <Tag>{value}</Tag>,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 110,
    render: (value) => <Tag color={STATUS_COLORS[value] || 'default'}>{value}</Tag>,
  },
  {
    title: 'Message',
    dataIndex: 'errorMessage',
    key: 'errorMessage',
    width: 200,
    render: (value) =>
      value ? <Text style={{ fontSize: 12 }}>{value}</Text> : <Text type="secondary">-</Text>,
  },
  {
    title: 'Metadata',
    dataIndex: 'metadata',
    key: 'metadata',
    render: renderMetadata,
  },
];

const SchedulerHistoryModal = ({ open, onCancel, portfolioId }) => {
  const { data, isLoading, isFetching } = useGetSchedulerRunHistoryQuery(portfolioId, {
    skip: !open || !portfolioId,
  });

  return (
    <Modal
      title={
        <Space>
          <HistoryOutlined />
          Scheduler Run History
        </Space>
      }
      open={open}
      onCancel={onCancel}
      onOk={onCancel}
      okText="Close"
      cancelButtonProps={{ style: { display: 'none' } }}
      width={1000}
      destroyOnHidden
    >
      <Spin spinning={isLoading || isFetching}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data || []}
          pagination={{ pageSize: 10, showSizeChanger: false }}
          size="small"
          scroll={{ x: 800 }}
        />
      </Spin>
    </Modal>
  );
};

SchedulerHistoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  portfolioId: PropTypes.string,
};

export default SchedulerHistoryModal;
